import { styled } from '@mui/material/styles';

import { NavigationList } from 'layout/MainLayout/components/Sidebar/components/components/NavigationList';
import { CLOSED_CONTENT_WIDTH } from 'layout/MainLayout/components/Sidebar/constants';
import { SidebarStateKey } from 'layout/MainLayout/components/Sidebar/store';
import {
  openedMixin,
  closedMixin,
} from 'layout/MainLayout/components/Sidebar/utils';

import type { Theme } from '@mui/material/styles';
import type { SidebarAnimatedComponentsState } from 'layout/MainLayout/components/Sidebar/types';

const closedNavigationListMixin = (theme: Theme) => ({
  width: CLOSED_CONTENT_WIDTH,
  ...closedMixin({ theme }),
});

const openedNavigationListMixin = (theme: Theme) => ({
  width: 220,
  ...openedMixin({ theme }),
});

export const NavigationListWrapper = styled(NavigationList, {
  shouldForwardProp: prop => prop !== SidebarStateKey.Opened,
})<SidebarAnimatedComponentsState>(({ theme, opened }) => ({
  overflowX: 'hidden',
  marginTop: theme.spacing(1),
  ...(opened && {
    ...openedNavigationListMixin(theme),
  }),
  ...(!opened && {
    ...closedNavigationListMixin(theme),
  }),
}));
